/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

export const getBookingProducts = (booking) => {
  if (booking?.products?.length) return booking.products;
  return booking?.invoice?.lines?.filter((line) => line.type === "product") || [];
};
